/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 绑定礼品卡
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  giftCardDTO: member.GiftCardDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/binding`,
    data: giftCardDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
